import React, { useState, useEffect } from "react";
import "./Forget_password.css";
import AppLayout from "../../../layout/AppLayout";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Phone_Number_Reset from "./Phone_Number_Reset/Phone_Number_Reset";
import Login_Header from "../../Common/Common_Component/Login_Header/Login_Header";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

const Forget_password = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);

  // Auto close modal and redirect
  useEffect(() => {
    if (modalShow) {
      const timer = setTimeout(() => {
        setModalShow(false);   // Close modal
        navigate("/login");    // Redirect
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalShow, navigate]);

  return (
    <>
      <div className="login-page SignUp Forget_password">
        {/* Header */}
        <Login_Header
          title="Forget password"
          subTitle="Please retrieve/change your password through your mobile phone number or email"
        />

        {/* Body */}
        <div className="login-body">
          <Phone_Number_Reset />

          {/* Privacy Agreement */}
          <div className="privacy_check mb-3">
            <Form.Check
              type="checkbox"
              label={
                <>
                  I have read and agree{" "}
                  <span className="privacy_link">[Privacy Agreement]</span>
                </>
              }
            />
          </div>

          {/* Buttons */}
          <Button
            className="btn_register_bg mb-3"
            onClick={() => setModalShow(true)}
          >
            Reset
          </Button>
        </div>
      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg="Password Reset Successfully!"
      />
    </>
  );
};

export default Forget_password;